export const TELEGRAM_WEB_APP_CONFIG = {
  scriptUrl: 'https://telegram.org/js/telegram-web-app.js?59',
  baseUrl: 'https://t.me',
} as const;
